import React from 'react';

const skills = [
    {
        id: 1,
        icon: 'bx bx-brain',
        title: 'AI/ML Development',
        description: 'Building intelligent systems using ML, Deep Learning, and Neural Networks. Expertise in TensorFlow, PyTorch, and scikit learn. Experience with computer vision, NLP, and recommendation systems. MSc thesis on AI oral health diagnostics for NHS.',
        link: '#portfolio'
    },
    {
        id: 2,
        icon: 'bx bx-code-curly',
        title: 'Full Stack Web Dev',
        description: 'Creating responsive web applications using MERN stack (MongoDB, Express, React, Node.js) and Django. Designed 6+ full stack applications at Bikashsoft Inc., driving 30% increase in user engagement. Proficient in modern frontend and backend technologies.',
        link: '#portfolio'
    },
    {
        id: 3,
        icon: 'bx bx-data',
        title: 'Data Science',
        description: 'Data analysis, visualization, and engineering pipelines. Experience with preprocessing data for AI models, building ETL pipelines, and working with SQL/NoSQL databases. Achieved 92% accuracy on Titanic survival prediction model.',
        link: '#portfolio'
    },
    {
        id: 4,
        icon: 'bx bx-code-alt',
        title: 'Software Engineering',
        description: 'Expert in Data Structures and Algorithms, Object Oriented Design, and clean code principles. Proficient in Python, Java, C/C++, C#, and JavaScript. 5+ years of professional software development experience across multiple industries.',
        link: '#portfolio'
    }
];

function Services() {
    return (
        <section className="services" id="services">
            <h2 className="heading">My <span>Skills</span></h2>
            <div className="services-container">
                {skills.map((skill) => (
                    <div className="services-box" key={skill.id}>
                        <i className={skill.icon}></i>
                        <h3>{skill.title}</h3>
                        <p>{skill.description}</p>
                        <a href={skill.link} className="btn">View Projects</a>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Services;